import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../api.service';
import { FunctionsService } from "../services/functions.service";
import { Router, ActivatedRoute } from '@angular/router';
import {} from 'googlemaps';
import jwt_decode from 'jwt-decode';
import { NgxPermissionsService } from 'ngx-permissions';
import {TranslateService, LangChangeEvent} from '@ngx-translate/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { VerifyEmailComponent } from '../register/verify-email/verify-email.component';
import { AuthService } from '../guards/auth.service';
import { SignalRService } from '../services/signalr.service';
import { AlertComponent } from './alert/alert.component';
import { AppConstants } from 'src/app/app.constants';
import { ViewAlertComponent } from './alert/view-alert/view-alert.component';
import { NotificationService } from '../services/notification.service';
import { StatusModalComponent } from '../generic-components/status-modal/status-modal.component';
import { OkModalComponent } from '../generic-components/ok-modal/ok-modal.component';
import { AttemptModalComponent } from '../generic-components/attempt-modal/attempt-modal.component';
import { LateModalComponent } from '../generic-components/late-modal/late-modal.component';
import { OkHtmlModalComponent } from '../generic-components/ok-html-modal/ok-html-modal.component';

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.css'],
    providers: [AlertComponent, ViewAlertComponent]
})

export class MainComponent implements OnInit {
    translateFunc: any;
    role:string;
    modalOptions: NgbModalOptions = {};
    navbarOpen = false;
    timer: any;
    zoneTimer: any;
    elapsed_time:any;
    modalRef:any;
    isBroadcastRegistered: boolean = false;
    alertDate: any;
    lang = "EN";
    alertNotified: any;
    alertStatusNotified: any;
    statusNotified: any;
    notified: boolean = false;
    refreshComponent: boolean = false;
    zoneRefreshComponent: boolean = false;
    userZone:string;
    newNotification: NotificationService[] = [];
    newAlertNotification: NotificationService[] = [];
    notificationList: NotificationService[] = [];
    alertNotificationList: NotificationService[] = [];
    notificationTimer: any;
    openedBell: boolean = false;
    toggleNavbar() {
        this.navbarOpen = !this.navbarOpen;
    }

    constructor(
        private apiService: ApiService, 
        public signalRService: SignalRService,
        public functionsService:FunctionsService,
        private permission: NgxPermissionsService,
        private route: ActivatedRoute,
        private router: Router,
        private translate: TranslateService,
        private modalService: NgbModal,
        private authService: AuthService,
        private alertComponent: AlertComponent,
        private viewAlertComponent: ViewAlertComponent
    ) {
        translate.setDefaultLang('en');
        this.translateFunc = functionsService;
    }
    language = localStorage.getItem('language')?localStorage.getItem('language'):'en';
    buttonLang = { color: 'black' }
    @ViewChild(AlertComponent) ac: AlertComponent;
    async ngOnInit() {
        this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            this.lang = event["lang"];
        });
        await this.apiService.getModalTimer().subscribe(async result => {
            localStorage.setItem('modalTimer', result['modalTimer']);
        });
        await this.apiService.getLanguage().subscribe(async result => {
            localStorage.setItem('langSetting', result['language']);
        });
        /*await this.apiService.getAgentDispatch().subscribe(async result => {
            localStorage.setItem('agentDispatch', result['agentDispatch']);
            localStorage.setItem('geoAssignment', result['geoAssignment']);
        });*/
        await this.apiService.getAssignedZone().subscribe(async data=>{
            if(data != null && data['active']){
                this.userZone = data['id']? data['id'].toString(): "InField";
            }
            else {
                this.userZone = "InField";
            }
        });
        if(localStorage.getItem("signOut") == "2"){
            this.functionsService.signOut();
        }
        this.getLocalNotifications();
        localStorage.setItem("signOut", '0');
        
        localStorage.setItem('isOwner', "0");
        $("#menu-toggle").click(function(e) {
            e.preventDefault();
            $("#wrapper").toggleClass("toggled");
        });
        if(localStorage.getItem('language') != null){
            this.translateFunc.useLanguageRed(localStorage.getItem('language'));
        }else{ 
            this.translateFunc.useLanguageRed('en');
        }
        if(localStorage.getItem('role') != null){
            this.role = localStorage.getItem('role');
            localStorage.setItem("isBroadcastRegistered", this.isBroadcastRegistered ? "true" : "false");
        
            if(this.role != undefined){
                var picUrl = await this.apiService.getProfilePicture().toPromise()
                localStorage.setItem('profilePicture', picUrl);
                //Verify if users exists and is active
                (await this.apiService.verifyUser()).subscribe(
                    async data => {
                        if(!data){
                            this.router.navigateByUrl('/login');
                            return;
                        }
                        if((this.role == "Activate")){
                            if((localStorage.getItem('active') == '2'))
                                {
                                //User did not enter the verification code
                                var email = localStorage.getItem('email');                                
                                this.apiService.resendCode({"Email":email,"Language":this.language.toUpperCase()}).subscribe(
                                    data => {
                                        //Show verify account modal
                                        this.modalOptions.backdrop = 'static';
                                        this.modalOptions.keyboard = false;
                                        const modalRef = this.modalService.open(VerifyEmailComponent, this.modalOptions);
                                        modalRef.componentInstance.email = email;
                                        modalRef.componentInstance.userLang = this.lang.toUpperCase();
                                    },
                                    error => {
                                        this.functionsService.errorHandler(error["status"]);
                                    }
                                )
                            }else{
                                this.permission.addPermission([this.role]);
                                this.router.navigateByUrl('/main/account'); 
                            }
                        }else{ 
                            this.permission.addPermission([this.role]);
                            if(localStorage.getItem('Expired') == '1'){
                                this.permission.addPermission("Expired");
                                if((localStorage.getItem("isBroadcastRegistered") == "true")){
                                    localStorage.setItem("signOut", "2");
                                    this.signalRService.connection.stop();
                                } 
                            }else{
                                this.signalRService.connect();
                                this.permission.hasPermission("Expired").then( response => { if(localStorage.getItem("isBroadcastRegistered") == "false" && !response) {
                                    localStorage.setItem("isBroadcastRegistered", "true");
                                    this.alertNotified = 0;
                                    this.alertStatusNotified = 0;
                                    this.statusNotified = 0;
                                    //Add user to group (which is organization ID)
                                    this.signalRService.connection.on('BroadcastMessage', (type: string, payload: string) => {
                                        var obj = JSON.parse(payload);
                                        var alertZone = obj.agentZone!= 0? obj.agentZone:obj.initialZone != 0? obj.initialZone: "InField";
                                        if (localStorage.getItem('geoAssignment')){
                                            if(this.alertNotified != obj.id && this.role != 'SecurityAgent' && this.role != 'Supervisor'){
                                                this.alertNotified = obj.id;
                                                var noti = {} as NotificationService;
                                                noti.message = "alert.new_alert";
                                                noti.alertId = obj.id;
                                                noti.alertType = type;
                                                noti.type = 1;
                                                noti.id = Math.random().toString(36).substring(2, 9);
                                                this.newAlertNotification.push(noti);
                                                this.alertNotificationList.push(noti);
                                                this.saveNotificationsLocally();
                                                this.authService.isLoggedIn = true;
                                                this.alertComponent.clearFilter(true);
                                            }
                                            else if (this.alertNotified != obj.id && ((this.role == 'SecurityAgent' || this.role == 'Supervisor') &&
                                                (this.userZone == alertZone || this.userZone == "InField" || alertZone == "InField"))){
                                                this.alertNotified = obj.id;
                                                var noti = {} as NotificationService;
                                                noti.message = "alert.new_alert";
                                                noti.alertId = obj.id;
                                                noti.alertType = type;
                                                noti.type = 1;
                                                noti.id = Math.random().toString(36).substring(2, 9);
                                                this.newAlertNotification.push(noti);
                                                this.alertNotificationList.push(noti);
                                                this.saveNotificationsLocally();
                                                this.authService.isLoggedIn = true;
                                                this.alertComponent.clearFilter(true); 
                                            }
                                        }
                                        else{
                                            if(this.alertNotified != obj.id){
                                                this.alertNotified = obj.id;
                                                var noti = {} as NotificationService;
                                                noti.message = "alert.new_alert";
                                                noti.alertId = obj.id;
                                                noti.alertType = type;
                                                noti.type = 1;
                                                noti.id = Math.random().toString(36).substring(2, 9);
                                                this.newAlertNotification.push(noti);
                                                this.alertNotificationList.push(noti);
                                                this.saveNotificationsLocally();
                                                this.authService.isLoggedIn = true;
                                                this.alertComponent.getAlerts();
                                            }
                                        }
                                    });

                                    this.signalRService.connection.on('BroadcastStatus', async (payload: string) => {
                                        var closedAlert = false;
                                        var obj = JSON.parse(payload);
                                        var user_id = localStorage.getItem('userId');
                                        var message = "";
                                        var alertZone = obj.agentZone!= 0? obj.agentZone:obj.initialZone != 0? obj.initialZone: "InField";
                                        if((this.alertStatusNotified != obj.id) || ((this.alertStatusNotified == obj.id) && (this.statusNotified != obj.status))){
                                            if(obj.status === 2 && !obj.attendedBy){return}
                                            this.alertStatusNotified = obj.id;
                                            this.statusNotified = obj.status;
                                            if(localStorage.getItem('language') != null){
                                                this.translateFunc.useLanguageRed(localStorage.getItem('language'));
                                            }else{ 
                                                this.translateFunc.useLanguageRed('en');
                                            }
                                            if ((!this.alertComponent.notified)) {
                                                this.alertComponent.notified = true;
                                                switch(obj.status){
                                                    case 1:
                                                        message = (obj["offZone"]=="0")?((obj["falseAlert"]=="1")?"alert.fa_content":"alert.ab_content"):"alert.oz_content";
                                                        break;
                                                    case 2:
                                                        message = "alert.ba_content";
                                                        break;
                                                    case 3:
                                                        message = "alert.ca_content";
                                                        break;
                                                    case 4:
                                                        message = "alert.ca_content";
                                                        break;
                                                    case 8:
                                                        message = "alert.ca_system";
                                                        break;
                                                    case "reassigned":
                                                        obj.attendedBy = obj.reassignedBy;
                                                        message = "alert.rt_content";
                                                        break;
                                                }
                                                if (localStorage.getItem('geoAssignment')){
                                                    if (((user_id != obj.attendedBy) || (obj.status == 3) || (obj.status == 1)) && ((this.role != 'SecurityAgent' && this.role != 'Supervisor'))) {
                                                        var noti = {} as NotificationService;
                                                        noti.message = message;
                                                        noti.alertId = obj.id;
                                                        noti.attendedName = obj.attendedName;
                                                        if(obj.status === 1) {closedAlert = true}
                                                        noti.closedAlert = closedAlert;
                                                        noti.type = 1;
                                                        noti.id = Math.random().toString(36).substring(2, 9);
                                                        this.newNotification.push(noti);
                                                        this.notificationList.push(noti);
                                                        this.saveNotificationsLocally();
                                                        var r = this.route["_routerState"]["snapshot"]["url"];
                                                        if(r.includes("/main/activeAlerts/view-alert")){
                                                            var alertId = r.split("/main/activeAlerts/view-alert/");
                                                            if(alertId[1]==obj.id && obj.status == 1){
                                                                this.router.navigate(["main"]);
                                                            }
                                                            if(alertId[1]==obj.id && obj.status == 3){
                                                                this.viewAlertComponent.fetchAlert(obj.id, true);
                                                            }
                                                        }
                                                    }
                                                    else if (((user_id != obj.attendedBy) || (obj.status == 3)) || (obj.status == 1) && ((this.role == 'SecurityAgent' || this.role == 'Supervisor')) &&
                                                        (this.userZone == alertZone || this.userZone == "InField" || alertZone == "InField")) {
                                                        var noti = {} as NotificationService;
                                                        noti.message = message;
                                                        noti.alertId = obj.id;
                                                        noti.attendedName = obj.attendedName;
                                                        if(obj.status === 1) {closedAlert = true}
                                                        noti.closedAlert = closedAlert;
                                                        noti.type = 1;
                                                        noti.id = Math.random().toString(36).substring(2, 9);
                                                        this.newNotification.push(noti);
                                                        this.notificationList.push(noti);
                                                        this.saveNotificationsLocally();
                                                        var r = this.route["_routerState"]["snapshot"]["url"];
                                                        if(r.includes("/main/activeAlerts/view-alert")){
                                                            var alertId = r.split("/main/activeAlerts/view-alert/");
                                                            if(alertId[1]==obj.id && obj.status == 1){
                                                                this.router.navigate(["main"]);
                                                            }
                                                            if(alertId[1]==obj.id && obj.status == 3){
                                                                this.viewAlertComponent.fetchAlert(obj.id, true);
                                                            }
                                                        }
                                                    }
                                                }
                                                else{
                                                    if (((user_id != obj.attendedBy) || (obj.status == 3)) || (obj.status == 1)) {
                                                        var noti = {} as NotificationService;
                                                        noti.message = message;
                                                        noti.alertId = obj.id;
                                                        noti.attendedName = obj.attendedName;
                                                        if(obj.status === 1) {closedAlert = true}
                                                        noti.closedAlert = closedAlert;
                                                        noti.type = 1;
                                                        noti.id = Math.random().toString(36).substring(2, 9);
                                                        this.newNotification.push(noti);
                                                        this.notificationList.push(noti);
                                                        this.saveNotificationsLocally();
                                                        var r = this.route["_routerState"]["snapshot"]["url"];
                                                        if(r.includes("/main/activeAlerts/view-alert")){
                                                            var alertId = r.split("/main/activeAlerts/view-alert/");
                                                            if(alertId[1]==obj.id && obj.status == 1){
                                                                this.router.navigate(["main"]);
                                                            }
                                                            if(alertId[1]==obj.id && obj.status == 3){
                                                                this.viewAlertComponent.fetchAlert(obj.id, true);
                                                            }
                                                        }
                                                    }
                                                }
                                                this.alertComponent.clearFilter(true);
                                            }
                                        }
                                    });

                                    this.signalRService.connection.on('BroadcastRefresh', async (webjob: boolean, userId: number) => {
                                        var role = await this.functionsService.getRole();
                                        var loggedInUser = localStorage.getItem('userId');
                                        if(userId !=0){
                                            if(userId.toString() == loggedInUser){
                                                this.zoneRefreshComponent = true;
                                                this.zoneTimer = setInterval( ()=> {
                                                    window.location.reload();
                                                    this.stopInterval();
                                                }, 180000);
                                            }
                                        }else{
                                            if(webjob){
                                                this.refreshComponent = true;
                                                this.timer = setInterval( ()=> {
                                                    window.location.reload();
                                                    this.stopInterval();
                                                }, 180000);
                                            }else{
                                                if(role!="Owner"){
                                                    this.refreshComponent = true;
                                                    this.timer = setInterval( ()=> {
                                                        window.location.reload();
                                                        this.stopInterval();
                                                    }, 180000);
                                                }
                                            }
                                        }
                                    });

                                    this.signalRService.connection.on('BroadcastLateAlertsCount', (unattended: number, attending: number) => {
                                            var noti = {} as NotificationService;
                                            noti.message = "general.late_alerts";
                                            noti.unattended = unattended;
                                            noti.attending = attending;
                                            noti.type = 6;
                                            noti.id = Math.random().toString(36).substring(2, 9);
                                            this.newNotification.push(noti);
                                            this.notificationList.push(noti);
                                            this.saveNotificationsLocally();
                                    });

                                    this.signalRService.connection.on('BroadcastZone', async (id: number, zoneName: string, action: string) => {
                                        var userId = localStorage.getItem('userId');
                                        if(userId == id.toString() && action == 'ADDED'){
                                            var noti = {} as NotificationService;
                                            noti.message = "geofencing.zone_assigned";
                                            noti.zoneName = zoneName;
                                            noti.type = 2;
                                            noti.id = Math.random().toString(36).substring(2, 9);
                                            this.newNotification.push(noti);
                                            this.notificationList.push(noti);
                                            this.saveNotificationsLocally();
                                        }
                                        else if(userId == id.toString() && action == 'REMOVED'){                                            
                                            var noti = {} as NotificationService;
                                            noti.message = "geofencing.zone_removed";
                                            noti.zoneName = zoneName;
                                            noti.type = 2;
                                            noti.id = Math.random().toString(36).substring(2, 9);
                                            this.newNotification.push(noti);
                                            this.notificationList.push(noti);
                                            this.saveNotificationsLocally();
                                        }
                                        else if(userId == id.toString() && action == 'ACTIVATED'){                                            
                                            var noti = {} as NotificationService;
                                            noti.message = "geofencing.zone_activated";
                                            noti.zoneName = zoneName;
                                            noti.type = 2;
                                            noti.id = Math.random().toString(36).substring(2, 9);
                                            this.newNotification.push(noti);
                                            this.notificationList.push(noti);
                                            this.saveNotificationsLocally();
                                        }
                                        else if(userId == id.toString() && action == 'INACTIVATED'){                                            
                                            var noti = {} as NotificationService;
                                            noti.message = "geofencing.zone_inactivated";
                                            noti.zoneName = zoneName;
                                            noti.type = 2;
                                            noti.id = Math.random().toString(36).substring(2, 9);
                                            this.newNotification.push(noti);
                                            this.notificationList.push(noti);
                                            this.saveNotificationsLocally();
                                        }
                                    });

                                    this.signalRService.connection.on('BroadcastDispatch', (status: number, payload: string) => {
                                        var obj = JSON.parse(payload);
                                        var userId = localStorage.getItem('userId');                                        
                                        if(status == 5){
                                            var noti = {} as NotificationService;
                                            noti.message = "alert_activity.dispatch";
                                            noti.modalMessage = "alert_activity.dispatch_message"; 
                                            noti.reason = obj.message;
                                            noti.userName = obj.user;
                                            noti.attempts = obj.attemptCount;
                                            noti.agents = obj.agents;
                                            noti.alertId = obj.alertId;
                                            noti.type = 5;
                                            noti.id = Math.random().toString(36).substring(2, 9);
                                            this.newNotification.push(noti);
                                            this.notificationList.push(noti);
                                            this.saveNotificationsLocally();
                                            var r = this.route["_routerState"]["snapshot"]["url"];
                                            if(r.includes("/main/activeAlerts/view-alert")){
                                                var alertId = r.split("/main/activeAlerts/view-alert/");
                                                if(alertId[1]==obj.alertId){
                                                    this.viewAlertComponent.fetchAlert(obj.alertId, true);
                                                }
                                            }
                                        }
                                        else if(status == 4 && userId != obj.id){
                                            var noti = {} as NotificationService;
                                            noti.message = "alert_activity.release";
                                            noti.modalMessage = "alert_activity.agent_release_message";
                                            noti.reason = obj.message;
                                            noti.type = 4;
                                            noti.alertId = obj.alertId;
                                            noti.agentName = obj.agent;
                                            noti.id = Math.random().toString(36).substring(2, 9);
                                            this.newNotification.push(noti);
                                            this.notificationList.push(noti);
                                            this.saveNotificationsLocally();
                                        }
                                        else if(status == 3 && userId != obj.id){
                                            var noti = {} as NotificationService;
                                            noti.message = "alert_activity.agent_released";
                                            noti.alertId = obj.alertId;
                                            noti.agentName = obj.agent;
                                            noti.type = 1;
                                            noti.id = Math.random().toString(36).substring(2, 9);
                                            this.newNotification.push(noti);
                                            this.notificationList.push(noti);
                                            this.saveNotificationsLocally();
                                            var r = this.route["_routerState"]["snapshot"]["url"];
                                            if(r.includes("/main/activeAlerts/view-alert")){
                                                var alertId = r.split("/main/activeAlerts/view-alert/");
                                                if(alertId[1]==obj.alertId){
                                                    this.viewAlertComponent.fetchAlert(obj.alertId, true);
                                                }
                                            }
                                        }
                                        else if(status == 2 && userId != obj.id){
                                            var noti = {} as NotificationService;
                                            noti.message = "alert_activity.reject";
                                            noti.message2 = "alert.rejected_reason";
                                            noti.modalMessage = "alert.rejected_message";
                                            noti.reason = obj.message;
                                            noti.alertId = obj.alertId;
                                            noti.agentName = obj.agent;
                                            noti.type = 3;
                                            noti.id = Math.random().toString(36).substring(2, 9);
                                            this.newNotification.push(noti);
                                            this.notificationList.push(noti);
                                            this.saveNotificationsLocally();
                                        }
                                        else if(status == 1 && userId != obj.id){
                                            var noti = {} as NotificationService;
                                            noti.message = "alert.rejected_message";
                                            noti.alertId = obj.alertId;
                                            noti.agentName = obj.agent;
                                            noti.type = 1;
                                            noti.id = Math.random().toString(36).substring(2, 9);
                                            this.newNotification.push(noti);
                                            this.notificationList.push(noti);
                                            this.saveNotificationsLocally();
                                        }
                                        else if(status == 0 && userId != obj.id){
                                            var noti = {} as NotificationService;
                                            noti.message = "alert.ignored_message";
                                            noti.alertId = obj.alertId;
                                            noti.agentName = obj.agent;
                                            noti.type = 1;
                                            noti.id = Math.random().toString(36).substring(2, 9);
                                            this.newNotification.push(noti);
                                            this.notificationList.push(noti);
                                            this.saveNotificationsLocally();
                                        }
                                    });

                                    this.signalRService.connection.on('BroadcastSignOut', async (userId: number, deleted: boolean) => {
                                        var loggedUserId = localStorage.getItem('userId');
                                        if(userId.toString() == loggedUserId){
                                            this.modalOptions.backdrop = 'static';
                                            this.modalOptions.keyboard = false;
                                            this.modalOptions.size = 'lg';
                                            const modalRef = this.modalService.open(OkHtmlModalComponent, this.modalOptions);
                                            if(deleted){
                                                modalRef.componentInstance.title = this.translate.instant('general.deleted');
                                                modalRef.componentInstance.message = this.translate.instant('user.user_deleted');
                                                this.translate.onLangChange.subscribe(() => {
                                                modalRef.componentInstance.title = this.translate.instant('general.deleted');
                                                modalRef.componentInstance.message = this.translate.instant('user.user_deleted');
                                                });
                                            }
                                            else{
                                                localStorage.setItem("signOut", "2");
                                                modalRef.componentInstance.title = this.translate.instant('password.password_changed');
                                                modalRef.componentInstance.message = this.translate.instant('password.mobile_password_changed');
                                                this.translate.onLangChange.subscribe(() => {
                                                modalRef.componentInstance.title = this.translate.instant('password.password_changed');
                                                modalRef.componentInstance.message = this.translate.instant('password.mobile_password_changed');
                                                });
                                            }
                                            modalRef.result.then(() => this.functionsService.userSignOut());
                                        }
                                    });
                                }})
                            }
                        }
                    },
                    error => {
                        this.router.navigateByUrl('/login'); 
                    }
                )
            }
        }
        else{
            this.router.navigateByUrl('/login'); 
        }
    }

    closeNotificationBanner(id){
        this.newNotification.forEach((element,index)=>{
            if(element.id==id) this.newNotification.splice(index,1);
         });

         this.saveNotificationsLocally();
    }

    closeAlertNotificationBanner(id){
        this.newAlertNotification.forEach((element,index)=>{
            if(element.id==id) this.newAlertNotification.splice(index,1);
         });

         this.saveNotificationsLocally();
    }

    closeAlertNotification(id){
        this.alertNotificationList.forEach((element,index)=>{
            if(element.id==id) this.alertNotificationList.splice(index,1);
         });

         this.saveNotificationsLocally();
    }

    closeNotification(id){
        this.notificationList.forEach((element,index)=>{
            if(element.id==id) this.notificationList.splice(index,1);
         });

         this.saveNotificationsLocally();
    }

    viewNotification(notification){
        this.closeAlertNotification(notification.id);
            
        this.closeNotification(notification.id);

        this.saveNotificationsLocally();

        if(notification.type == 1){
            this.router.navigateByUrl('/main/activeAlerts/view-alert/' + notification.alertId);
        }
        else if(notification.type == 3){
            const modalRef = this.modalService.open(StatusModalComponent, { size: 'lg' });
            modalRef.componentInstance.title = this.translate.instant('alert.rejected');
            modalRef.componentInstance.message = notification.modalMessage;
            modalRef.componentInstance.message2 = notification.message2;
            modalRef.componentInstance.reason = notification.reason;
            modalRef.componentInstance.alertId = notification.alertId;
            modalRef.componentInstance.agentName = notification.agentName;
        }
        else if(notification.type == 4){
            const modalRef = this.modalService.open(OkModalComponent, { size: 'lg' });
            modalRef.componentInstance.reason = notification.reason;
            modalRef.componentInstance.message = notification.modalMessage;
            modalRef.componentInstance.title = this.translate.instant('alert.alert_number') + notification.alertId;
        }
        else if(notification.type == 5){
            const modalRef = this.modalService.open(AttemptModalComponent, { size: 'lg' });
            modalRef.componentInstance.message = notification.modalMessage
            modalRef.componentInstance.attempts = notification.attempts;
            modalRef.componentInstance.agents = notification.agents;
            modalRef.componentInstance.alertId = notification.alertId;
            modalRef.componentInstance.userName = notification.userName;
            modalRef.componentInstance.title = this.translate.instant('alert.alert-status');
        }
        else if(notification.type == 6){
            const modalRef = this.modalService.open(LateModalComponent, { size: 'lg' });
            modalRef.componentInstance.unattended = notification.unattended;
            modalRef.componentInstance.attending = notification.attending;
        }
    }

    trackNotification(index: number, notification){
        return notification.id;
    }

    clearNotifications() { 
        this.newAlertNotification = [];
        this.newNotification = [];
        this.saveNotificationsLocally();
    }

    clearNotificationList() {
        this.alertNotificationList = [];
        this.notificationList = [];
        this.saveNotificationsLocally();
    }

    saveNotificationsLocally(){
        localStorage.setItem('newAlertNotification', JSON.stringify(this.newAlertNotification))
        localStorage.setItem('newNotification', JSON.stringify(this.newNotification))
        localStorage.setItem('alertNotificationList', JSON.stringify(this.alertNotificationList))
        localStorage.setItem('notificationList', JSON.stringify(this.notificationList))
    }

    getLocalNotifications(){
        this.newAlertNotification = localStorage.getItem('newAlertNotification') ? JSON.parse(localStorage.getItem('newAlertNotification')) : [];
        this.newNotification = localStorage.getItem('newNotification')? JSON.parse(localStorage.getItem('newNotification')): [];
        this.alertNotificationList = localStorage.getItem('alertNotificationList')? JSON.parse(localStorage.getItem('alertNotificationList')): [];
        this.notificationList = localStorage.getItem('notificationList')? JSON.parse(localStorage.getItem('notificationList')): [];
    }

    checkDropDown(open:boolean) {
        this.openedBell = open;
    }

    get fullName() {
        var fullName = localStorage.getItem('fullName')?localStorage.getItem('fullName'):"";   
        return fullName;
    }

    get profilePicture() {
        var profilePicture = (localStorage.getItem('profilePicture') != "null")?localStorage.getItem('profilePicture'):'assets/images/default-user.jpeg';
        return profilePicture; 
    }

    stopInterval(){
        clearInterval(this.timer);
    }
}